import React from 'react'
import {Lang} from 'yougile-lang'
import {Menu} from '@components/menu'
import {Overlay} from '@components/overlay'

type Props = {
  stickerValues: JSX.Element[]
  cb: () => void
  unpin: () => void
}

const maxHeightAbsolute = 360

export const CustomStickerMenuMultiActions = (props: Props) => {
  const {stickerValues, cb, unpin} = props
  const [maxHeight, setMaxHeight] = React.useState(maxHeightAbsolute)

  return (
    <Menu storeMaxHeight={setMaxHeight} onEscape={cb}>
      <Overlay onClick={cb} />
      <div
        className="relative flex flex-col bg-main-old rounded-4 z-2000 shadow-task-old"
        style={{maxHeight}}
      >
        <div className="sticker-item-list-head min-w-176">
          {Lang.msg.stickerStates2}
          <span className="_link sticker-item-unpin" onClick={unpin}>
            {Lang.msg.unpin}
          </span>
        </div>
        <div className="overflow-auto" style={{maxHeight}}>
          {stickerValues}
        </div>
      </div>
    </Menu>
  )
}
